import { FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { drilldownData, ModuleFields } from "~/Utils/drilldownData";
export type FormType = "loginPage";

export const fields: any = {
  mobileLoginPage: drilldownData["mobileLoginPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  mobileCalendarPage: drilldownData["mobileCalendarPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  webLoginPage: drilldownData["webLoginPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType, note }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      note: note
    })
  ),
  mainLoginPage: drilldownData["mainLoginPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType,note }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      note:note
    })
  ),
  vendorLoginPage: drilldownData["vendorLoginPage"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType, note }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      note: note
    })
  ),
  forgotPassword: drilldownData["forgotPassword"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType, note }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      note: note
    })
  ),
  signUp: drilldownData["signUp"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType, note }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      note: note
    })
  ),
};
